import { CSSInterpolation } from '@mui/system';

export default {
  fontFamily: 'Roboto',
  fontWeight: 600,
  fontSize: '14px',
  boxShadow: 'none',
  textTransform: 'none',
  borderRadius: '20px',
  paddingLeft: '24px',
  paddingRight: '24px',
} as CSSInterpolation;
